import cn from "@/helpers/classNames";
import { ComponentProps } from "@tw-classed/react";

import { TableCell } from "../../Table";

export function StickyActionCell(props: ComponentProps<typeof TableCell>) {
  return (
    <TableCell
      {...props}
      className={cn(
        "no-row-hover sticky right-0 animate-sticky-table-row-action-scroll-shadow bg-background py-0 pr-1 pl-1.5 will-change-[filter]",
        props.className,
      )}
      style={{
        animationTimeline: "scroll(inline)",
        ...props.style,
      }}
      onClick={(e) => {
        e.stopPropagation();
        props.onClick?.(e);
      }}
    >
      {props.children}
    </TableCell>
  );
}
